import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BRAND, LOGO_URL, TID } from "../lib/brand";
import { subscribeNewsletter } from "../lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  const year = new Date().getFullYear();

  const onSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await subscribeNewsletter(email);
      setOk(true);
      setEmail("");
    } catch (err) { /* silent */ }
    finally { setBusy(false); }
  };

  return (
    <footer data-testid={TID.footer.root} className="relative mt-24 md:mt-32 border-t border-ink-700 bg-ink-950">
      <div className="wrap py-16 md:py-24 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img src={LOGO_URL} alt="ProForm" className="h-16 w-auto mb-6" />
          <p className="text-chrome-300 text-sm max-w-md leading-relaxed">
            Denver&apos;s paint and body specialists for JDM, imported, drift, race, performance, and everyday vehicles.
            Insurance repairs. Custom refinishing. Fifteen years of hands-on craft.
          </p>
          <form onSubmit={onSubscribe} className="mt-8 max-w-md">
            <label className="field-label" htmlFor="footer-email">Occasional updates. No spam.</label>
            <div className="flex gap-0">
              <input
                id="footer-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="field flex-1"
                data-testid="footer-newsletter-input"
              />
              <button type="submit" disabled={busy} data-testid="footer-newsletter-submit" className="btn btn-primary">
                {busy ? "..." : ok ? "Subscribed" : "Join"}
              </button>
            </div>
          </form>
        </div>

        <div className="md:col-span-2">
          <div className="label mb-4">Site</div>
          <ul className="space-y-2 text-chrome-100 text-sm">
            <li><Link to="/services" className="hover:text-proform-red">Services</Link></li>
            <li><Link to="/gallery" className="hover:text-proform-red">Gallery</Link></li>
            <li><Link to="/about" className="hover:text-proform-red">About</Link></li>
            <li><Link to="/partners" className="hover:text-proform-red">Partners</Link></li>
            <li><Link to="/insurance" className="hover:text-proform-red">Insurance</Link></li>
            <li><Link to="/careers" className="hover:text-proform-red">Careers</Link></li>
            <li><Link to="/events" className="hover:text-proform-red">Events</Link></li>
            <li><Link to="/merch" className="hover:text-proform-red">Merch</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="label mb-4">Legal</div>
          <ul className="space-y-2 text-chrome-100 text-sm">
            <li><Link to="/privacy" className="hover:text-proform-red">Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-proform-red">Terms</Link></li>
            <li><Link to="/accessibility" className="hover:text-proform-red">Accessibility</Link></li>
            <li><Link to="/portal" className="hover:text-proform-red">Customer Portal</Link></li>
            <li><Link to="/admin/login" className="hover:text-proform-red">Admin</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="label mb-4">Contact</div>
          <ul className="space-y-3 text-chrome-100 text-sm">
            <li><a href={`tel:${BRAND.phoneRaw}`} className="hover:text-proform-red block">Call · {BRAND.phoneDisplay}</a></li>
            <li><a href={`sms:${BRAND.phoneRaw}`} className="hover:text-proform-red block">Text · {BRAND.phoneDisplay}</a></li>
            <li><a href={`mailto:${BRAND.email}`} className="hover:text-proform-red block break-all">{BRAND.email}</a></li>
            <li><a href={BRAND.instagramUrl} target="_blank" rel="noreferrer" className="hover:text-proform-red block">Instagram · @{BRAND.instagramHandle}</a></li>
            <li className="text-chrome-300">Service area: Denver Metro &amp; the Colorado Front Range</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ink-700">
        <div className="wrap py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-mono text-[11px] tracking-[0.24em] text-chrome-300">
          <div>© {year} PROFORM PAINT &amp; BODY · BUILT DIFFERENT. FINISHED RIGHT.</div>
          <div>DENVER · COLORADO · USA</div>
        </div>
      </div>
    </footer>
  );
}
